import { FaCoffee } from "react-icons/fa";
import "./FloatingCoffeeButton.css";
import { useTranslation } from "../i18n";

function FloatingCoffeeButton() {
  const { t } = useTranslation();

  return (
    <a
      className="floating-coffee-button"
      href="https://buymeacoffee.com/theqahub"
      target="_blank"
      rel="noreferrer"
      aria-label={t("coffee.aria")}
      title={t("coffee.title")}
    >
      <FaCoffee aria-hidden="true" />
      <span>{t("coffee.cta")}</span>
    </a>
  );
}

export default FloatingCoffeeButton;
